import PageHeader from 'layout/components/PageHeader';
import PageContainer from 'layout/components/PageContainer';
import RulesConfigurationForm from './components/RulesConfigurationForm/RulesConfigurationForm';
import { useTrafficLightRulesConfigurations } from './hooks/useTrafficLightRulesConfigurations';
import { Button } from '@vadiun/react-components';
import { useHistory, useLocation } from 'react-router-dom';
import { RulesConfigurationFormType } from './types/types';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const TrafficLightRulesConfigurationItemPage = () => {
  const { search } = useLocation();
  const readOnlyByParams =
    new URLSearchParams(search).get('readOnly') === 'true';

  const [readOnly, setReadOnly] = useState<boolean>(readOnlyByParams);
  const { detailQuery, updateMutation } = useTrafficLightRulesConfigurations();
  const history = useHistory();
  const configuration = detailQuery.data;
  const loadingConfiguration = detailQuery.isLoading;

  const handleUpdate = async (values: RulesConfigurationFormType) => {
    if (!configuration) return;
    try {
      await updateMutation.mutate({ id: configuration.id, values });
      history.goBack();
    } catch (error) {
    }
  };

  return (
    <>
      <PageHeader
        area="Inventarios"
        subArea="Gestión Semáforos"
        title={
          readOnly
            ? 'Detalle de configuración de regla'
            : 'Editar configuración de regla'
        }
        toolbar={
          <>
            {readOnly && (
              <Button
                variant="light"
                color="primary"
                onClick={() => setReadOnly(false)}
              >
                <FontAwesomeIcon icon={faPencilAlt} className="mr-2" />
                Editar
              </Button>
            )}
          <Button
            variant="light"
            color="primary"
            onClick={ () =>  history.goBack() }
          >
            Volver
          </Button>
          </>
        }
      />
      <PageContainer>
        <div className="flex justify-center items-center h-full w-full">
          {!loadingConfiguration && configuration && (
            <RulesConfigurationForm
              initialData={configuration}
              readOnly={readOnly}
              onSubmit={readOnly ? undefined : handleUpdate}
            />
          )}
        </div>
      </PageContainer>
    </>
  );
};

export default TrafficLightRulesConfigurationItemPage;
